import React from 'react';
import classnames from 'classnames';
import { Tooltip } from '@reach/tooltip';

const Avatar = ({
    size = 100,
    name = '',
    label = '',
    corners = 'rounded',
    className = '',
    closeable = false,
    clickable = false,
    onClose = () => {},
    onClick = () => {}
}) => {
    let initalsStyles = {
        top: `${size * 0.25}px`,
        fontSize: `${size * 0.5}px`,
        lineHeight: `${size * 0.5}px`
    };
    let avatarStyles = {
        width: size,
        height: size
    };
    let overlayStyles = {
        fontSize: `${size * 0.5}px`,
        lineHeight: `${size * 0.5}px`
    };

    return (
        <Tooltip label={label}>
            <div
                className={classnames('avatar', className, {
                    'avatar-circle': corners === 'circle',
                    'avatar-rounded': corners === 'rounded',
                    'avatar-clickable': clickable
                })}
                style={avatarStyles}
                onClick={clickable ? onClick : undefined}
            >
                <div className="initials" style={initalsStyles}>
                    {name}
                </div>
                {closeable && (
                    <div className="avatar-overlay" style={overlayStyles}>
                        <button
                            className="close"
                            style={{
                                top: -2,
                                fontSize: size,
                                lineHeight: `${size}px`
                            }}
                            onClick={onClose}
                        >
                            &times;
                        </button>
                    </div>
                )}
            </div>
        </Tooltip>
    );
};

export default Avatar;
